import { JobBoardCodename } from '@core/job-boards-types';
import { JobBoardCredentialKey } from '@recruitee/job-boards-types';
import type { JobBoard } from '@recruitee/job-boards-types';

import { snakeToCamelCase } from '../../legacy/lib/helpers';

export const jobBoardRequiresCredentials = (jobBoard: JobBoard): boolean =>
  !!jobBoard.credentialsStructure?.length && !isIndeed(jobBoard);

export const isIndeed = (jobBoard: JobBoard): boolean =>
  jobBoard.codename === JobBoardCodename.Indeed;

export const isLinkedin = (jobBoard: JobBoard): boolean =>
  jobBoard.codename === JobBoardCodename.Linkedin;

export const jobBoardHasCredentials = (jobBoard: JobBoard): boolean =>
  !!jobBoard.credentials?.length;

export const isIndeedWithoutCredentials = (jobBoard: JobBoard): boolean =>
  isIndeed(jobBoard) && !jobBoardHasCredentials(jobBoard);

export const isLinkedinPostingWithoutValidCredential = (jobBoard: JobBoard): boolean => {
  if (!isLinkedin(jobBoard) || !jobBoardHasCredentials(jobBoard) || !jobBoard.posting) {
    return false;
  }

  const emailKey = snakeToCamelCase(JobBoardCredentialKey.LinkedinPosterEmail);

  return jobBoard.credentials?.some(credential => !credential.data[emailKey]) ?? false;
};

export const isLinkedinWithoutValidCredential = (jobBoard: JobBoard): boolean => {
  if (isLinkedin(jobBoard) && jobBoardHasCredentials(jobBoard)) {
    const emailKey = snakeToCamelCase(JobBoardCredentialKey.LinkedinPosterEmail);

    return jobBoard.credentials?.some(credential => !credential.data[emailKey]) ?? false;
  }

  return false;
};
